/*
 * @Author: xiwl
 * @Date: 2022-03-17 17:16:30
 * @LastEditors: xiwl
 * @LastEditTime: 2022-04-06 10:20:23
 * @Descripttion: 验证码
 */
import React, { Component } from "react";
import { Button, message, Row, Col } from "antd";
import styles from "./index.less";
import axios from "axios";
import {withRouter} from 'react-router-dom';

let origin = window.location.origin;

if (origin === 'http://localhost:3000' || origin === 'http://127.0.0.1:3000') {
    origin = 'http://10.131.0.4';
}

class Checking extends Component {
    constructor(props){
        super(props);
        this.state = {
            imageWidth: "",
            validcodeImage: ""
        }
    }
    componentDidMount() {
        this.getCaptcha();
        this.setState({
          imageWidth: document.getElementById("slideBox").clientWidth
        });
    }
    componentWillUnmount() {
        this.setState = (state, cb) => {
            return;
        };
    }
    getCaptcha = () => {
        axios.get(`${window.globalConfig.path || origin}/pur/common/verifyCodeBase64`).then(res=>{
            if (res && res.data) {
                this.setState({validcodeImage: res.data.message});
            }
        });
    }
    onChange = (event) => {
        const value = event.target.value;
        if (!value) {
            this.setState({
                checkErrorPwd: true
            });
        } else {
            this.setState({ checkErrorPwd: false });
        }
    }
    onClick = e => {
        e.preventDefault();
        let form = this.refs.checkForm || {};
        let code = form['code'].value;
        if (!code) {
            this.setState({checkErrorPwd: true});
        } else {
            this.setState({loading: true});
            axios.get(`${window.globalConfig.path || origin}/pur/common/checkCode?code=${code}`).then(res=>{
                if (res.data.success) {
                    this.props.history.push({pathname: "/agreement", state: { isZiZhuCe: true, code }});
                } else {
                    message.error(res.data.message);
                    this.getCaptcha();
                }
                this.setState({ loading: false });
            }).catch((error) => {
                this.setState({ loading: false });
            });
        }
    }
    render() {
        let { imageWidth, checkErrorPwd, loading } = this.state;
        return <div id="slideBox" style={{ width: "100%" }}>
            <div className={styles.image_code} style={{ width: imageWidth }}>
                <form ref='checkForm'>
                    <Row gutter={8}>
                        <Col span={16}>
                        <input
                            name="code"
                            className={styles.normal_input}
                            placeholder='验证码'
                            style={{'borderColor': (checkErrorPwd ? '#f5222d' : '')}}
                            onChange={this.onChange}
                        />
                        <input style={{display: "none"}}/>
                        </Col>
                        <Col span={8} style={{lineHeight: "30px"}}>
                            <img
                                title="换一个"
                                src={'data:image/jpeg;base64,' + this.state.validcodeImage}
                                style={{ width: "100%", height: "30px", cursor: "pointer" }}
                                onClick={this.getCaptcha}
                            />
                        </Col>
                    </Row>
                    {checkErrorPwd ? <span style={{ color: '#f5222d', textIndent: '1em' }}>请输入验证码</span> : null}
                    <div>
                        <Button type="primary" onClick={this.onClick} className={styles.login_form_button} loading={loading}>确定</Button>
                    </div>
                </form>
            </div>
        </div>
    }
}

export default withRouter(Checking);